import React, { useEffect, useState } from "react";
import { ThreeDots } from "react-loader-spinner";
import { isMobile } from "react-device-detect";
import { useRouter } from "next/router";
const MapComponent = ({ coordinatesData, height }) => {
  const [mapLoaded, setMapLoaded] = useState(false);
  const [firstRender, setFirstRender] = useState(null);

  const router = useRouter();
  const isWorkshopNetwork = router.pathname == "/workshop-network" || "/services/[...slug]";

  useEffect(() => {
    
    if (JSON.stringify(firstRender) !== JSON.stringify(coordinatesData)) {


      const initializeMap = () => {
        // Define the bounds for Dubai
        const dubaiBounds = {
          north: 25.3548,
          south: 24.7317,
          west: 55.1991,
          east: 55.4521,
        };

        // Initialize the map with bounds for Dubai
        const map = new window.google.maps.Map(document.getElementById("map"), {
          center: { lat: 25.276987, lng: 55.296249 },
          zoom: 10,
        });
        setFirstRender(coordinatesData)
        const markerPositions = coordinatesData.map((coordinates) => ({
          lat: coordinates.Latitude,
          lng: coordinates.Longitude,
        }));

        const customMarker = {
          url: "/assets/images/map-OB.png",
          scaledSize: new window.google.maps.Size(40, 40), // scaled size
          origin: new window.google.maps.Point(0, 0), // origin
          anchor: new window.google.maps.Point(20, 40), // anchor
        };

        // Add markers to the map
        markerPositions.forEach((position) => {
          new window.google.maps.Marker({
            position: position,
            map: map,
            title: "Hello Dubai!",
            icon: customMarker, // Set custom marker icon
          });
        });

        // Set mapLoaded to true when the map is loaded
        setMapLoaded(true);

      };

      // Load the map script
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.NEXT_PUBLIC_GOOGLE_MAP_KEY}&libraries=places`;
      script.async = true;
      script.onload = initializeMap;

      document.body.appendChild(script);

      // Clean up function
      // return () => {
      //   document.body.removeChild(script);
      // };
    }
  }, [coordinatesData]); // Run only once on component mount

  return (
    <div style={{ width: "100%" }}>
      {!mapLoaded && (
        <div
          className={`${isWorkshopNetwork ? "position-absolute" : "position-relative"}`}
          style={{
            zIndex: 10,
            top: "42%",
            left: "50%",
            transform: "translate(-50%,-50%)",
          }}
        >
          <ThreeDots
            height="80"
            width="80"
            color="#0451be"
            radius="6"
            wrapperStyle={{}}
            wrapperClass="justify-content-center aling-items-center"
            visible={true}
            ariaLabel="rings-loading"
          />
        </div>
      )}
      <div
        id="map"
        className="map-height"
        style={{
          display: mapLoaded ? "block" : "none",
          width: "100%",
          height: `${height}`,
        }}
      ></div>
    </div>
  );
};

export default MapComponent;
